import {
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  ApiDeleteRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Saldo Awal Persediaan',
    title_form: 'Form Saldo Awal Persediaan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Saldo Persediaann',
        href: '/adm/fin/setting/saldo-persediaan',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_saldo_persediaan',
    sortDesc: true,
    fields: [
      {
        key: 'code_persediaan',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'code_prod',
        label: 'Kode Barang',
        sortable: true,
      },
      {
        key: 'product',
        label: 'Nama Barang',
        sortable: true,
      },
      {
        key: 'gudang',
        label: 'Gudang',
      },
      {
        key: 'stock_awal',
        label: 'Jumlah',
      },
      {
        key: 'harga_pokok_satuan',
        label: 'Harga Pokok',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  settingSaldoPersediaan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListSaldoPersediaan({ commit, state }) {
    commit('settingSaldoPersediaan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/saldo-persediaan`, params);
    commit('settingSaldoPersediaan', {
      loading: false,
    });

    if (!result.error) {
      commit('settingSaldoPersediaan', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async getDetailSaldoPersediaan({ commit, state }, payload = null) {
    commit('settingSaldoPersediaan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/saldo-persediaan/${payload.id}`);
    commit('settingSaldoPersediaan', {
      loading: false,
    });

    if (!result.error) {
      commit('settingSaldoPersediaan', {
        form: {
          ...data.form,
          ...result.data.object,
          date_persediaan: result.data.object.date_persediaan
            ? moment(result.data.object.date_persediaan).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async createSaldoPersediaan({ commit, state, dispatch }) {
    commit('settingSaldoPersediaan', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/saldo-persediaan`, state.data.form);
    commit('settingSaldoPersediaan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSaldoPersediaan({ commit, state, dispatch }, payload = null) {
    commit('settingSaldoPersediaan', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/saldo-persediaan/${payload.id}`,
      state.data.form
    );

    commit('settingSaldoPersediaan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSaldoPersediaan({ commit, dispatch }, payload = null) {
    commit('settingSaldoPersediaan', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/saldo-persediaan/${payload.id}`);
    commit('settingSaldoPersediaan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
